export default {
  setProduces(state, vegTypes){
      state.produces = vegTypes;
    }
  }